import { Input, InputAdornment, Box } from '@coolblue-development/freddy';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import RecipientField from '../Recipients/RecipientField';
import { Divider } from '@mui/material';
import { MAX_OUTBOUND_OTHER_RECIPIENTS } from '../../../../../utils/emailContactHelpers';

export interface OutboundEmailFields {
  to: string[];
  otherRecipients: string[];
  subject: string;
}

interface EmailOutboundHeaderProps {
  contactId: string;
  fields: OutboundEmailFields;
  onChange: (fields: OutboundEmailFields) => void;
}

const EmailOutboundHeader = ({ contactId, fields, onChange }: EmailOutboundHeaderProps): JSX.Element => {
  return (
    <Box
      sx={{
        border: '1px solid #DDDDDD',
        borderRadius: '4px 4px 0 0',
        display: 'flex',
        flexDirection: 'column'
      }}
      data-testid="outbound-header"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '12px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <RecipientField
              label="To"
              addLabel="Add recipient"
              recipients={fields.to}
              onChange={to => onChange({ ...fields, to })}
              maxRecipients={1}
              takenAddresses={fields.otherRecipients}
            />
          </Box>
          <CopyContactIdButton contactId={contactId} />
        </Box>
        <RecipientField
          label="Other recipients"
          addLabel="Add Other recipients"
          recipients={fields.otherRecipients}
          onChange={otherRecipients => onChange({ ...fields, otherRecipients })}
          maxRecipients={MAX_OUTBOUND_OTHER_RECIPIENTS}
          maxRecipientsMessage={`You can add up to ${MAX_OUTBOUND_OTHER_RECIPIENTS} other recipients`}
          takenAddresses={fields.to}
        />
      </Box>
      <Divider />
      <Input
        data-testid="outbound-subject"
        value={fields.subject}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...fields, subject: e.target.value })}
        startAdornment={<InputAdornment>Subject:</InputAdornment>}
        variant="borderless"
      />
    </Box>
  );
};

export default EmailOutboundHeader;
